module.exports = __webpack_public_path__ + "media/claim/assets/images/trustpilot/logo_black-5a63d97e71f1fea88271191e96752d67.png";